import { AxiosError } from 'axios';
export class BrowserException implements Error {
  name: string;
  code: string;
  message: string;
  constructor(error: AxiosError) {
    this.name = 'BrowserException';
    this.code = error.code || ''; //TODO either change it to a proper code or make it null/undefiend
    this.message = error.message || 'Browser Exception';
  }
}
